import React from 'react';
import { Helmet } from 'react-helmet';
import './LegalPage.css'; // Reusing the same CSS for a consistent look

const DatenschutzPage = () => {
  return (
    <div className="legal-page-container">
      <Helmet>
        <title>Datenschutz – Enzlo</title>
        <meta name="description" content="Datenschutzerklärung und Informationen zur Verarbeitung personenbezogener Daten bei Enzlo." />
        <link rel="canonical" href="https://enzlo.com/datenschutz" />
      </Helmet>

      <div className="legal-content">
        <h1>Datenschutzerklärung</h1>
        <p>Stand: Juli 2025</p>

        <div className="info-card">
          <h2>1. Verantwortliche Stelle</h2>
          <p>
            Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
          </p>
          <p>
            <strong>Spoddig UG (haftungsbeschränkt)</strong><br />
            Eckweg 8<br />
            64354 Reinheim<br />
            Deutschland
          </p>
          <p>
            <strong>Vertreten durch:</strong> Franziska Spoddig<br />
            <strong>Telefon:</strong> <a href="tel:+4915751619973">0157 516 19973</a><br />
            <strong>E-Mail:</strong> <a href="mailto:hi@enzlo.com">hi@enzlo.com</a>
          </p>
        </div>

        <div className="info-card">
          <h2>2. Datenschutzbeauftragter</h2>
          <p>
            Aufgrund unserer Unternehmensgröße sind wir gesetzlich nicht zur Benennung eines Datenschutzbeauftragten verpflichtet. Bei datenschutzrechtlichen Fragen können Sie sich jedoch jederzeit direkt an uns wenden.
          </p>
        </div>

        <h2>3. Allgemeine Grundsätze der Datenverarbeitung</h2>
        <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.</p>
        
        <h3>Rechtsgrundlagen der Verarbeitung</h3>
        <ul>
          <li>Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.</li>
          <li>Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.</li>
          <li>Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.</li>
          <li>Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage.</li>
          <li>Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.</li>
        </ul>

        <h3>2. YouTube</h3>
        <p>Unsere Internetpräsenz beinhaltet mindestens ein Plugin oder Videoplayer von YouTube, gehörig zur Google Inc., ansässig in San Bruno/Kalifornien, USA. [...]</p>

        <h3>3. Google Maps</h3>
        <p>Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited („Google“), Gordon House, Barrow Street, Dublin 4, Irland. [...]</p>

        {/* ... Include all other sections from your provided text ... */}

        <h2>I. Nutzung der SalesViewer®-Technologie</h2>
        <p>Auf dieser Webseite werden mit der SalesViewer®-Technologie der SalesViewer® GmbH auf Grundlage berechtigter Interessen des Webseitenbetreibers (Art. 6 Abs.1 lit.f DSGVO) Daten zu Marketing-, Marktforschungs- und Optimierungszwecken gesammelt und gespeichert. [...]</p>

        <h2>§ J Aktualität</h2>
        <p>Diese Datenschutzerklärung hat den Stand 09/10/2023.</p>

      </div>
    </div>
  );
};

export default DatenschutzPage;
